import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import { Section } from '../../models/menu.interfaces';

@Component({
  selector: 'idp-section-header',
  standalone: true,
  imports: [NgIf],
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss']
})
export class SectionHeaderComponent {
  @Input() details: Section = {} as Section;
  @Output() listItem: EventEmitter<Link> = new EventEmitter<Link>();
}
